<template>
  <div class="page-header">
    <h2 class="header-title">{{ pageName }}</h2>
    <div class="header-sub-title">
      <nav class="breadcrumb breadcrumb-dash">
        <router-link :to="`/`" class="breadcrumb-item">
          <i class="anticon anticon-home m-r-5"></i>Home
        </router-link>
        <router-link v-if="parentPageName" :to="parentPageUrl" class="breadcrumb-item">
          <i class="anticon anticon-home m-r-5"></i>{{ parentPageName }}
        </router-link>
        <a class="breadcrumb-item" href="#">{{ pageName }}</a>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageName: { required: true, type: String },
    parentPageName: { required: false, type: String },
    parentPageUrl: { required: false, type: String }
  },
  data () {
    return {}
  },
  methods: {}
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pageheader.vue